import { apiClient } from './client';

export interface LayerDefaultWellProfileCoefs {
  id: string;
  q0: number | null;
  a: number | null;
  wc0: number | null;
  k: number | null;
  q0_gas?: number | null;
  a_gas?: number | null;
}

export const layerDefaultWellProfilesApi = {
  getCoefsByLayer: (layerId: string): Promise<LayerDefaultWellProfileCoefs> => {
    return apiClient.get(`/layer-default-well-profiles/layer/${layerId}/coefs`);
  },
};
